import { useEffect, useMemo } from 'react';
import { useQueryClient } from 'react-query';
import * as Yup from 'yup';
import { CurrentCartQuery } from 'lib/home/generated/types/api';
import { useUpdateDraftOrderMutation } from 'lib/home/generated/queries';
import { medusaAddressFromStandardAddress } from 'lib/home/util/addresses';
import { addressValidation } from 'lib/forms/validation';
import { addressInitialValues } from 'lib/forms/initialValues';
import { AddressInputGroup } from '../../InputGroups';
import { useFormikContext } from 'formik';
import { CheckoutFormValues } from './CheckoutForm';
import throttle from 'lodash/throttle';

export const CheckoutFormShippingAddressInputGroup = () => {
  const queryClient = useQueryClient();
  const formikProps = useFormikContext<CheckoutFormValues>();
  const updateDraftOrderMutation = useUpdateDraftOrderMutation();

  const updateDraftOrder = async (values: typeof addressInitialValues) => {
    const addressSchema = Yup.object(addressValidation);
    const isValid = await addressSchema.isValid(values);
    const input = { shipping_address: medusaAddressFromStandardAddress(values) };

    if (isValid)
      updateDraftOrderMutation.mutate(
        { input },
        {
          onSuccess: data => {
            const {
              updateDraftOrder: { cart }
            } = data;

            queryClient.setQueryData(['CurrentCart'], (query: CurrentCartQuery) => {
              query.me.subscription.current_order.medusa_cart.tax_total = cart.tax_total;
              query.me.subscription.current_order.medusa_cart.total = cart.total;
              return query;
            });
          }
        }
      );
  };

  const throttledUpdateDraftOrder = useMemo(() => throttle(updateDraftOrder, 500), []);

  useEffect(() => {
    throttledUpdateDraftOrder(formikProps.values.shipping_address);
  }, [formikProps.values]);

  return <AddressInputGroup name="shipping_address" />;
};
